import React from 'react';
import algoliasearch from 'algoliasearch';
import PropTypes from 'prop-types';
import {
    InstantSearch,
    Configure,
    connectHits,
    connectPagination,
    connectSearchBox,
    connectStateResults,
} from 'react-instantsearch-dom';
import { Hits, Hit } from '../Algolia/Hits';
import SearchBox from '../Algolia/Search';
import Pagination from '../Algolia/Pagination';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { SearchInfo } from '../Algolia/SearchInfo';
import { Location } from '@reach/router';
import { urlParamsFromObject } from '../../utils/url';

const algoliaClient = algoliasearch('V69UUVP7D3', '5df5f497e633e10f59c7b79a517d3fdd');

const MaterialSearchBox = connectSearchBox(SearchBox);
const MaterialPagination = connectPagination(Pagination);
const CustomHits = connectHits(Hits);
const CustomStateResults = connectStateResults(SearchInfo);

const searchClient = {
    search(requests) {
        const [request] = requests;
        if (request.query === '' && request.facets.length === 0) {
            return;
        }
        return algoliaClient.search(requests);
    },
};

const styles = (theme) => ({
    content: {
        width: '75%',
        marginLeft: '12%',
        [theme.breakpoints.down('md')]: {
            width: '100%',
            margin: '0',
        },
    },
    searchBox: {
        marginBottom: '30px',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '72%',
    },
    aisInstantSearch: {
        width: '100%',
        letterSpacing: '0.5px',
    },
    hit: {},
    pagination: {
        marginTop: '75px',
    },
});

// ?query=Some&page=1&product=jet
const getFromPath = (path) => {
    const decodedPath = decodeURIComponent(path).replace('?', '');
    const splits = decodedPath.split('&');
    const state = splits.reduce((acc, item) => {
        const [key, value] = item.split('=');
        const pair = {};
        pair[key] = value;
        return Object.assign(acc, pair);
    }, {});

    return {
        page: state.page || 1,
        query: state.query || '',
        product: state.product || '',
    };
};

const getPresets = (props) => {
    const { location, product } = props;
    let state = {};
    if (location.search) {
        state = getFromPath(location.search);
    }
    if (product) {
        state.product = product;
    }

    return state;
};

class MainSearch extends React.Component {
    constructor(props) {
        super(props);
        this.state = getPresets(props);
        this.onSearchUpdate = this.onSearchUpdate.bind(this);
        this.onPaginationUpdate = this.onPaginationUpdate.bind(this);
        this.updateUrlParams = this.updateUrlParams.bind(this);
    }

    isSearchable = () => {
        return this.props.searchable !== 'false';
    };

    onSearchUpdate(state) {
        if (state.query !== undefined) {
            this.setState({ query: state.query }, this.updateUrlParams);
        }
    }

    onPaginationUpdate(page) {
        this.setState({ page }, this.updateUrlParams);
    }

    updateUrlParams() {
        if (this.state.query === '') {
            window.history.replaceState(null, '', '/search/');
            return;
        }
        const urlParams = urlParamsFromObject(this.state);
        window.history.replaceState(null, '', `?${urlParams}`);
    }

    componentDidUpdate() {
        if (this.isSearchable()) {
            return;
        }
        const preset = getPresets(this.props);
        if (preset.query !== this.state.query) {
            this.setState({ ...this.state, query: preset.query });
        }
    }

    render() {
        const { classes, searchable } = this.props;
        return (
            <Grid container spacing={24} className={searchable === 'false' ? {} : classes.content} direction="column">
                <div className={classes.aisInstantSearch}>
                    <InstantSearch
                        indexName="help-signiant-com"
                        searchClient={searchClient}
                        onSearchStateChange={this.onSearchUpdate}
                    >
                        {this.isSearchable() && (
                            <Grid container className={classes.searchBox} justify="flex-end">
                                <MaterialSearchBox defaultRefinement={this.state.query} />
                            </Grid>
                        )}
                        {this.state.query && (
                            <>
                                <Grid>
                                    <CustomStateResults />
                                </Grid>
                                <Grid xs={12} className={classes.hit}>
                                    <CustomHits hitComponent={Hit} />
                                </Grid>
                                <Grid xs={12} className={classes.pagination}>
                                    <MaterialPagination
                                        padding={3}
                                        showNext={true}
                                        totalPages={4}
                                        defaultRefinement={this.state.page}
                                        currentRefinement={this.state.page}
                                        onPaginationUpdate={this.onPaginationUpdate}
                                    />
                                </Grid>
                                <Configure
                                    hitsPerPage={7}
                                    query={this.state.query}
                                    facetFilters={`product:${this.state.product}`}
                                />
                            </>
                        )}
                    </InstantSearch>
                </div>
            </Grid>
        );
    }
}
const withLocation = (props) => {
    return <Location>{(locationProps) => <MainSearch {...locationProps} {...props}></MainSearch>}</Location>;
};

MainSearch.propTypes = {
    searchable: PropTypes.string,
    classes: PropTypes.object,
};

export default withStyles(styles)(withLocation);
